import request from '@/utils/request'

export function GetScheduleList(data) {
  return request({
    url: 'Training/GetScheduleList',
    method: 'post',
    data,
  })
}

export function GetTraningList(data) {
  return request({
    url: 'Training/GetTraningList',
    method: 'post',
    data,
  })
}

export function ExportTraningList(data) {
  return request({
    url: 'Training/ExportTraningList',
    method: 'post',
    data,
  })
}

export function DelSchedule(data) {
  return request({
    url: 'Training/DelSchedule',
    method: 'post',
    data,
  })
}
